import { render } from "./Certification.vue?vue&type=template&id=05a20216&scoped=true"
import script from "./Certification.vue?vue&type=script&lang=js"
export * from "./Certification.vue?vue&type=script&lang=js"

import "./Certification.vue?vue&type=style&index=0&id=05a20216&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-05a20216"]])

export default __exports__